import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import * as disputeActions from '../../../actions/disputeActions';
import Select from 'react-select';
// import * as signinActions from '../../actions/signinActions';
import { ToastContainer, toast } from 'react-toastify';
import validator from './../../common/validator.js';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

import {
    Modal,
} from 'react-bootstrap';

class AddSubDispute extends React.Component {
    constructor(props, context) {
        super(props, context);
        let {
            index,
            title,
            description,
            subDisputeId
        } = props.editableSubdispute
        this.state = {
            dispute: {
                value: '',
                isValid: false,
                message: ''
            },
            subDispute: {
                value: title !== "" ? title :'',
                isValid: title !== "" ? true: false,
                message: ''
            },
            resolution: {
                value: description !== "" ? description :'',
                isValid: description !== ""  ? true : false,
                message: ''
            },
            defaultDisputeValue: props.disputeOptions[0] ? props.disputeOptions[0] : {
                value: '', label: '',
            },
            disputeOptions: props.disputeOptions,
            selectedDisputedOption: index ? props.disputeOptions[index] : props.disputeOptions[0],
            savingSubCategory: false,
            editableSubdisputeId: subDisputeId !== '' ? subDisputeId : ''
        };
        this.handleChange = this.handleChange.bind(this)
        this.addSubDisputeCategory = this.addSubDisputeCategory.bind(this)
        this.changeSelectedDisputedOption = this.changeSelectedDisputedOption.bind(this)
    }

    componentWillReceiveProps(nextProps){
        console.log("cloeseaddedsubdisputemod==>", nextProps)
        if (nextProps.subDisputeContentAdded && this.state.savingSubCategory) {
            console.log("cloeseaddedsubdisputemod==>", this.props)
            this.props.closeAddSubDisputeModal();
            this.setState({
                savingSubCategory: false
            })
        }
    }

    handleChange(event) {
        var state = this.state;
        console.log("ddddddd", state, event.target.name)
        state[event.target.name].value = event.target.value;


        //validation code
        if (event.target.name == "dispute") {
            if (event.target.value.length > 0) {
                if (!validator.isValidName(event.target.value)) {
                    state[event.target.name].isValid = false;
                    state[event.target.name].message = 'Please Enter Dispute Category';
                } else {
                    state[event.target.name].isValid = true;
                    state[event.target.name].message = '';
                }
            } else {
                state[event.target.name].isValid = false;
                state[event.target.name].message = 'Please Enter Dispute Category';
            }
        }
        if (event.target.name == "subDispute") {
            if (event.target.value.length > 0) {
                if (!validator.isValidName(event.target.value)) {
                    state[event.target.name].isValid = false;
                    state[event.target.name].message = 'Please Enter Sub-Dispute Category';
                } else if (event.target.value.length > 20) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please Enter Sub-Dispute within 20 Characters';
				}else {
                    state[event.target.name].isValid = true;
                    state[event.target.name].message = '';
                }
            } else {
                state[event.target.name].isValid = false;
                state[event.target.name].message = 'Please Enter Sub-Dispute Category';
            }
        }
        else if (event.target.name == "resolution") {
            if (event.target.value.length > 0) {
                if (!validator.isValidName(event.target.value)) {
                    state[event.target.name].isValid = false;
                    state[event.target.name].message = 'Please Enter Resolution For this Dispute';
                } else {
                    state[event.target.name].isValid = true;
                    state[event.target.name].message = '';
                }
            } else {
                state[event.target.name].isValid = false;
                state[event.target.name].message = 'Please Enter Resolution For this Dispute';
            }

        }

        this.setState(state);
    }

    changeSelectedDisputedOption(selectedOption) {
        let disputeOptions = this.state.disputeOptions
        let i = disputeOptions.indexOf(selectedOption);
        // console.log("selectedOption=====+>", selectedOption, i)
        this.setState({
            selectedDisputedOption: disputeOptions[i]
            // selectedOption.value
        });
    }
    addSubDisputeCategory() {
        let state = this.state
        if(!state.selectedDisputedOption){
            this.props.noDisputeAdded();
            // toast.error("Please Add Dispute Category First");
        }else if (state.subDispute.isValid && state.resolution.isValid) {
            let state = this.state;
            let disputeObj = {
                disputeCategory: state.selectedDisputedOption.value,
                disputeId: state.selectedDisputedOption._id,
                title: state.subDispute.value,
                description: state.resolution.value,
            }
            this.setState({
                savingSubCategory: true
            })
            console.log("disputeobj", disputeObj);
            if (this.state.editableSubdisputeId !== '') {
                disputeObj.subDisputeId = this.props.editableSubdispute.subDisputeId !== '' ? this.state.editableSubdisputeId  : '';
                this.props.disputeActions.editSubDisputeCategory(disputeObj, this.props)
            }else{
                // return
                this.props.disputeActions.addSubDisputeCategory(disputeObj,this.props)

            }

        } else {
            console.log("DISPUT$E IS EVLAU", state)
            // state.dispute.message = state.dispute.isValid ? '' : "Please Enter Dispute Category"
            state.subDispute.message = state.subDispute.isValid ? '' : "Please Enter Sub-Dispute Category"
            state.resolution.message = state.resolution.isValid ? '' : "Please Enter Resolution For this Dispute"
            this.setState(state)
        }
    }

    deleteUser(item) {

		confirmAlert({
			title: 'Confirm',
			message: "Do you wish to delete this  Subdispute Category ",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let userObject = {
							subDisputeId: item._id
						}
						// let userId = user._id
						this.props.disputeActions.deleteSubDispute(userObject, this.props);
					}
				},
				{
					label: 'No',
					// onClick: () => { this.props.history.push('/user/userList'); }
				}
			]
		})

	}
    render() {

        console.log('openAddDisputeModal:', this.state, this.props)
        return (
            <Modal className="blockAvailability" show={this.props.openAddDisputeModal} size="lg" onHide={this.props.closeAddSubDisputeModal}>
					{/* <ToastContainer /> */}

                <Modal.Header>
                    <Modal.Title align="left">
                        {/* <h4>Recurrence <span><i class="fa fa-refresh recur ml-20"></i></span></h4> */}
                        {/* <div className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="Enter blocks of time where you will be unavailable and select the appropriate reason."> */}
                        {/* </div> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="loginInput1">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="">
                                            <label> Dispute Category </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                            <Select
                                                // styles={customStyles}
                                                value={this.state.selectedDisputedOption}
                                                onChange={this.changeSelectedDisputedOption}
                                                options={this.state.disputeOptions}
                                                defaultValue={this.state.defaultDisputeValue}
                                            />
                                            {/* <a onClick={this.deleteUser.bind(this, this.state.disputeOptions._id)} style={{ "cursor": "pointer" }} className="redLink"><i className="fa fa-trash"></i></a> */}
                                            {/* <input style={{ width: '100%' }} name="dispute" type="text" value={this.state.dispute ? this.state.dispute.value : ''} onChange={this.handleChange} placeholder="enter here" /> */}
                                        </div>
                                        <span className="help-block">{this.state.dispute.message}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <div className="loginInput1">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="">
                                            <label >Sub-Dispute Category </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                            <input style={{ width: '100%' }}
                                            name="subDispute"
                                            type="text"
                                            value={this.state.subDispute.value}
                                            placeholder="Enter Sub-Dispute Here"
                                            onChange={this.handleChange}
                                            />
                                        </div>
                                        <span className="help-block">{this.state.subDispute.message}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="loginInput1">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="">
                                            <label> Resolution </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                            <textarea style={{ width: '100%', height: "100px" }}
                                             name="resolution"
                                             type="text"
                                             value={this.state.resolution.value}
                                             placeholder="Enter Sub-Dispute Description Here"
                                             onChange={this.handleChange}
                                             />
                                        </div>
                                        <span className="help-block">{this.state.resolution.message}</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="btnSubmit text-center" style={{ margin: "auto" }}>
                        <button className="btn btn-primary" onClick={() => this.addSubDisputeCategory()}>Ok</button>&nbsp;
                        <button className="btn btn-primary" onClick={this.props.closeAddSubDisputeModal}>Cancel</button>
                    </div>
                </Modal.Footer>
            </Modal >
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        subDisputeContentAdded: state.dispute.subDisputeContentAdded,
        // AddSubDispute: state.AddSubDispute
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        disputeActions: bindActionCreators(disputeActions, dispatch),

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddSubDispute);